import React from 'react'
import TRFRegistrationListComponent from '../Components/B2bRegistration/TRFRegistrationListComponent'

function TRFRegistrationListPage() {
    return (

        <TRFRegistrationListComponent />
    )
}

export default TRFRegistrationListPage